import React from "react";
import { CheckCircle2, XCircle, Shield, BookOpen, FileText } from "lucide-react";

const WhatWeOffer = () => {
  const offers = [
    {
      icon: Shield,
      title: "Curated Med Spa Peptide Catalog",
      description: "Ten peptides organized by category — anti-aging, weight loss, recovery, longevity, and sexual wellness."
    },
    {
      icon: FileText,
      title: "Ingredient & Specification Transparency",
      description: "Clear labeling with sequence info, form, purity tier, and applicable research notes."
    },
    {
      icon: BookOpen,
      title: "Plain-English Education",
      description: "Evidence-led articles on peptide chemistry, study quality, regulatory status, and what the research actually shows."
    }
  ];

  const avoids = [
    "Disease claims or medical diagnoses",
    "Aesthetic outcome guarantees",
    "Prescription comparisons or alternatives",
    "Claims to cure, heal, or treat conditions"
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* What You'll Find */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-[#3a2a26] mb-4">
            What You'll Find Here
          </h2>
          <p className="text-[#7a6b62] max-w-2xl mx-auto">
            A med-spa-focused storefront with a curated peptide catalog and evidence-led educational content.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-20">
          {offers.map((item) => (
            <div
              key={item.title}
              className="bg-[#fffaf5] border border-[#f0d8d4] rounded-2xl p-8 hover:border-[#d4a5ad] transition-all"
            >
              <div className="w-14 h-14 bg-[#fdf2f4] rounded-xl flex items-center justify-center mb-6">
                <item.icon className="w-7 h-7 text-[#b89a6d]" />
              </div>
              <h3 className="text-xl font-bold text-[#3a2a26] mb-3">{item.title}</h3>
              <p className="text-[#7a6b62]">{item.description}</p>
            </div>
          ))}
        </div>

        {/* What We Avoid */}
        <div className="bg-[#fffaf5] border border-[#e8d4d0] rounded-2xl p-8 md:p-12">
          <div className="flex items-center gap-3 mb-6">
            <XCircle className="w-6 h-6 text-[#c47267]" />
            <h3 className="text-2xl font-bold text-[#3a2a26]">What We Avoid</h3>
          </div>
          <p className="text-[#7a6b62] mb-6">
            We're committed to honest, compliant product information. You won't find:
          </p>
          <div className="grid md:grid-cols-2 gap-4">
            {avoids.map((item) => (
              <div key={item} className="flex items-center gap-3">
                <XCircle className="w-5 h-5 text-[#c47267] flex-shrink-0" />
                <span className="text-[#5a4a40]">{item}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatWeOffer;
